import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';

import {
  getMasterDataChangeConfiguration,
  MasterdataChangeRequestType,
  MasterdataChangeType,
  masterDataSelectionTranslateKeys,
} from '@resident-nx/shared';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-selection',
  imports: [ReactiveFormsModule, RouterLink, TranslateModule],
  templateUrl: './user-profile-edit-selection.component.html',
  styleUrl: './user-profile-edit-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class UserProfileEditSelectionComponent {
  #store = inject(Store);
  public readonly MasterDataChangeRequestType = MasterdataChangeRequestType;
  goToConcerns = output();
  rawConfig = this.#store.selectSignal(getMasterDataChangeConfiguration);
  config = computed(() =>
    this.rawConfig().filter(entry => entry.changeType !== MasterdataChangeType.PAYMENT)
  );

  activeHint = computed(() =>
    this.config()?.some(config => config.requestType === MasterdataChangeRequestType.TICKET)
  );
  protected readonly translateKeys = masterDataSelectionTranslateKeys;
}
